export const DASHBOARD_ACCOMPLISHMENT = '/dashboard/accomplishment';
export const DASHBOARD_SCORE_RECORD_LIST = '/dashboard/scorerecord';
export const DASHBOARD_SCORE_RECORD_DETAIL =
  '/dashboard/scorerecord/:subjectId/:recordId';

// routes for tutor
export const MATERY = 'MATERY';
export const ASSESSMENT = 'ASSESSMENT';
export const STUDENT = 'STUDENT';
export const STUDENT_SCORE_RECORD = 'STUDENT_SCORE_RECORD';

export const DASHBOARD_MASTERY = '/dashboard/mastery';
export const DASHBOARD_CONCEPTS =
  '/dashboard/mastery/subtopic/:subtopicId/semester/:semesterId/class/:classId/subject/:subjectId';
export const DASHBOARD_ASSESSMENTS = '/dashboard/assessments';
export const DASHBOARD_ASSESSMENT_DETAIL =
  '/dashboard/assessments/details/:assessmentId';
export const DASHBOARD_STUDENTS = '/dashboard/students';
export const DASHBOARD_STUDENT_DETAIL =
  '/dashboard/students/:studentId/semester/:semesterId/subject/:subjectId/class/:classId';
export const DASHBOARD_STUDENT_SCORE_RECORD =
  '/dashboard/students/:studentId/semester/:semesterId/subject/:subjectId/record/:recordId/class/:classId';
export const DASHBOARD_PRACTICE = '/dashboard/practice';
export const DASHBOARD_ACCOMPLISHMENT_FOR_STUDENT = `${DASHBOARD_CONCEPTS}/student/:studentId`;



// WEBPACK FOOTER //
// ./app/constants/dashboardRouting.js